export enum TimeStrategy {
  LockEnd = 'lock-end',
  LockDuration = 'lock-duration',
}
